import React, { PureComponent } from 'react'
import { translations } from 'gipsy-misc'

import container from './container'
import AuthBackground from 'features/auth/components/background'
import { LoginButtons } from 'gipsy-ui'

class InviteAcceptPage extends PureComponent {
  render() {
    const { onGoogleLogin, onMicrosoftLogin, noInvitation, displayEmailText } = this.props
    return (
      <AuthBackground title={translations.auth.gotInvite}>
        <p>{translations.auth.inviteText}</p>
        {displayEmailText ? <p>{translations.auth.inviteEmailWarning}</p> : ''}
        {noInvitation ? (
          <p style={{ color: 'red' }}>You are not invited.</p>
        ) : (
          <LoginButtons onGoogleLogin={onGoogleLogin} onMicrosoftLogin={onMicrosoftLogin} />
        )}
      </AuthBackground>
    )
  }
}

export default container(InviteAcceptPage)



// WEBPACK FOOTER //
// ./src/pages/inviteAcceptPage/index.js